// extracted by mini-css-extract-plugin
export default {"total-campaigns":"Ended_total-campaigns__C8aOK","button":"Ended_button__8I8m9","switch":"Ended_switch__xh1mO","slider":"Ended_slider__ecwgR","round":"Ended_round__iL3+H"};